// ✂️ 한국어 줄 끊기의 «붙은 말» 판정 — 한 정의를 두 곳이 쓴다(회장님 2026-09-23 «단어 잘림» · 2안 승인):
//   · 데이터 줄 나누기(gen-verbatim-plan.captionLinesOf) — 끊는 자리 값 매기기
//   · 화면 폭 접기(wrap-display-line) — 앞에서부터 채우기는 그대로, 붙은 말 사이에서만 한두 어절을 내린다
// 두 곳이 따로 적으면 «데이터는 안 떼는데 화면은 떼는» 식으로 갈린다.

/* ── 붙은 말 사전(회장님 2026-09-24 «근본적으로 어려운 건 근본부터») ─────────────────────────────────────
 * 한 글자 말은 ★방향이 둘★ 이다. «가입할 수 · 무서운 건 · 이별 뒤 · 발생 시 · 1,600만 원» 은 ★앞말★ 에 붙고,
 * «한 달 · 낸 보험료 · 또 만났네요 · 꼭 소개해» 는 ★뒷말★ 에 붙는다. 종전(09-23)의 «한 글자면 다음 줄로»는
 * 앞말에 붙는 쪽을 거꾸로 떼어 냈다(dev 1,060 경계 실측: «무서운 / 건» · «가입할 / 수 있고» 등).
 * ⇒ 방향을 사전으로 정하고, ★사전에 없는 말은 건드리지 않는다★(모르면 종전 채우기 — 더 나쁘게 만들지 않는다). */

/** 조사·어미 꼬리(붙은 말 뒤에 붙어도 같은 말로 본다). */
//   ★«의» 는 뺀다★ — «거의»(부사 · 뒷말에 붙는다)가 «거+의» 로 읽혀 줄 첫머리 금지가 됐다.
const JOSA = "(?:은|는|이|가|을|를|도|만|에|에서|에는|엔|로|으로|과|와|이다|입니다|이에요|예요|이라|이라서|이지만|이면|인|일|이죠|이야)?";
/** 끝 문장부호·따옴표(판정에서 뗀다). */
const TAIL_PUNCT = "[.,!?…\"'”’」』)]*";

/** 앞말에 붙는 의존명사·조사성 명사 — 줄 첫머리에 오면 안 된다(뒤에 조사 허용).
 *  ★뺀 말(실측 오탐)★ «바»(«바로»=바+로) · «등»(«등 굽은»=몸의 등) · «적»·«중»·«시»·«김»·«줄» 은 아래 좁은 꼴로만 판정한다. */
const BACK_NOUNS = "수|것|거|건|걸|게|데|때|때문|덕분|뿐|만큼|듯|채|척|동안|정도|대로|뒤|후|쯤|터|탓|뻔|지경|무렵|사이|이상|이하|미만|이내";
/** 조사를 좁게 받는 의존명사 — «적은»(형용사) · «중도»(명사) · «시도»(명사) · «김»(성씨) · «줄이면»(동사)과 갈라야 해서. */
const BACK_NARROW = "시(?:에|에는|엔)?|중(?:에|에서|에는|엔|인|이다|입니다|이에요|이죠)?|적(?:이|도)|김에|덕에";
/** 앞말에 붙는 보조용언(«-아/어/게/고» 뒤) — 줄 첫머리에 오면 안 된다. */
const AUX = "주세요|줘요|줘|주고|주면|주셔서|주십시오|주시고|주시면|줄게요|드려요|드립니다|드릴게요|드리고|드리면|보세요|봐요|봤어요|버렸다|버렸어요|버려요|있다|있어|있어요|있어서|있고|있죠|있지|있지만|있습니다|있으니|있으면|있는|있을|있던|있었다|있었어요|있다는|있다고|없다|없어|없어요|없어서|없고|없죠|없지만|없습니다|없으니|없으면|없는|없을|없던|없었다|없었어요|없다는|없다고";
/** 숫자 뒤에만 붙는 단위 — 앞말이 숫자일 때만 줄 첫머리 금지(«원을 그린다» 같은 명사는 건드리지 않는다). */
const COUNTERS = "원|명|개|번|년|월|일|살|세|분|초|건|배|회|차|째|권|장|대|벌|곳|층|호|평|위|점|퍼센트|킬로|달";
/** 뒷말에 붙는 말(관형사·수관형사·부사·한 글자 관형형) — 줄 끝에 오면 안 된다. */
//   ★«안» 은 뺀다★ — 부정(«안 돼요»)과 «지하철 안»(속)을 글자로 못 가른다(실측 오탐).
const FORWARD = "한|두|세|네|새|헌|온|각|매|몇|첫|그|이|저|그런|이런|저런|어떤|무슨|어느|모든|여러|다른|거의|아주|너무|매우|가장|제일|조금|약간|또|꼭|더|잘|왜|못|확|딱|좀|참|늘|곧|막|쭉|싹|다|덜|푹|꽉|낸|본|준|할|될|갈|볼|올|쓴|든|된|뺀";

/** 줄 첫머리에 오면 안 되는 말(앞말에 붙는 말) — 의존명사 · 보조용언. 뒤에 조사·문장부호만 허용. */
export const BOUND_HEAD_RE = new RegExp(`^(?:(?:${BACK_NOUNS})${JOSA}|(?:${BACK_NARROW})|(?:${AUX}))${TAIL_PUNCT}$`, "u");
const COUNTER_RE = new RegExp(`^(?:${COUNTERS})${JOSA}${TAIL_PUNCT}$`, "u");
const FORWARD_RE = new RegExp(`^(?:${FORWARD})$`, "u");
/** 숫자로 끝나는 말(«1,600만» · «30» · «세» 앞의 «스무» …). */
const NUMERAL_TAIL_RE = /(?:[0-9]|만|억|천|백|십|한|두|세|네|다섯|여섯|일곱|여덟|아홉|열|스무|몇)$/u;

/** «할 줄 · 갈 줄» 의 «줄» — 앞말이 ㄹ 받침 관형형일 때만 의존명사다(«둘째 줄» 의 줄은 명사 · 테스트 픽스처 실측). */
const JUL_RE = new RegExp(`^줄(?:은|도|을)?${TAIL_PUNCT}$`, "u");
function endsWithRieul(word: string): boolean {
  const ch = (word ?? "").replace(/[^\p{L}\p{N}]+$/u, "").slice(-1);
  const code = ch.codePointAt(0) ?? 0;
  return code >= 0xac00 && code <= 0xd7a3 && (code - 0xac00) % 28 === 8;
}

/** 뒷말에 붙는 말만으로 된 어절인가(«낸»·«또»·«꼭»·«한»). 문장부호가 붙으면 아니다(«네.»). */
export function isForwardWord(word: string): boolean {
  return FORWARD_RE.test(word ?? "");
}

/** words[i-1] 과 words[i] 사이에서 끊으면 붙은 말이 갈라지는가. */
export function isBoundBreak(words: readonly string[], i: number): boolean {
  if (i <= 0 || i >= words.length) return false;
  const prev = words[i - 1] ?? "";
  const next = words[i] ?? "";
  if (BOUND_HEAD_RE.test(next)) return true;
  if (JUL_RE.test(next) && endsWithRieul(prev)) return true;
  if (COUNTER_RE.test(next) && NUMERAL_TAIL_RE.test(prev)) return true;
  // «30 세» 의 «세» 처럼 숫자 뒤 단위로 쓰인 말은 앞말에 붙어 있다 — 뒷말에 붙는 말로 보지 않는다.
  if (COUNTER_RE.test(prev) && i >= 2 && NUMERAL_TAIL_RE.test(words[i - 2] ?? "")) return false;
  return isForwardWord(prev);
}

/**
 * 앞에서부터 채운 줄의 끝(`end` · 배타)이 붙은 말 사이면, 그 말을 다음 줄로 내릴 끝을 돌려준다.
 * 줄에는 최소 한 어절을 남긴다 — 그래도 못 고치면 채운 끝 그대로(모양을 더 나쁘게 만들지 않는다).
 */
export function backOffBoundBreak(words: readonly string[], start: number, end: number): number {
  if (end >= words.length) return end;
  let k = end;
  while (k - 1 > start && isBoundBreak(words, k)) k--;
  return isBoundBreak(words, k) ? end : k;
}

/** 문장 끝(닫는 따옴표 허용) — 여기서 끊긴 경계는 붙은 말 판정 대상이 아니다. */
const SENTENCE_END_RE = /[.!?…。？！]["”’」』')]*$/u;

/**
 * ✂️ 이미 나뉜 줄(어절 묶음)들 사이의 경계가 붙은 말을 가르면, 앞 줄 꼬리 한두 어절을 다음 줄 머리로 옮긴다.
 *   — 줄을 만드는 모든 곳(대본 분할·자동 자막·바로제작 자막 계획·저장된 줄 수리)이 ★같은 후처리★ 를 쓴다.
 *   어절에 시각이 붙어 있으면(자동 자막) 그대로 따라가므로 시각이 틀어지지 않는다.
 * 규칙: 줄 수는 그대로 · 앞 줄은 비우지 않는다 · 문장이 끝난 경계는 건드리지 않는다 ·
 *   `fits` 가 거절하면(받는 줄이 한도를 넘으면) 그 경계는 그대로(종전보다 나빠지지 않게).
 */
export function shiftBoundBreaksAcrossGroups<T>(
  groups: ReadonlyArray<ReadonlyArray<T>>,
  textOf: (t: T) => string,
  fits?: (group: readonly T[]) => boolean,
  /** 이 경계(k ↔ k+1)를 옮겨도 되는가 — 유저가 직접 구성한 줄 등은 호출부가 막는다. */
  canShift?: (k: number) => boolean,
): T[][] {
  const out = groups.map((g) => [...g]);
  for (let k = 0; k + 1 < out.length; k++) {
    if (canShift && !canShift(k)) continue;
    const a = out[k];
    const b = out[k + 1];
    if (!a.length || !b.length) continue;
    if (SENTENCE_END_RE.test(textOf(a[a.length - 1]))) continue;
    const words = [...a, ...b].map(textOf);
    if (!isBoundBreak(words, a.length)) continue;
    const cut = backOffBoundBreak(words, 0, a.length);
    if (cut <= 0 || cut >= a.length) continue;
    const next = [...a.slice(cut), ...b];
    if (fits && !fits(next)) continue;
    out[k] = a.slice(0, cut);
    out[k + 1] = next;
  }
  return out;
}

/** 줄(문자열) 배열 버전 — 어절은 공백으로 가른다. 바뀐 줄이 없으면 입력과 같은 내용. */
export function shiftBoundBreaksAcrossLines(lines: readonly string[], fits?: (line: string) => boolean): string[] {
  const groups = lines.map((l) => (l ?? "").trim().split(/\s+/).filter(Boolean));
  const shifted = shiftBoundBreaksAcrossGroups(groups, (w) => w, fits ? (g) => fits(g.join(" ")) : undefined);
  return shifted.map((g, i) => (g.length ? g.join(" ") : lines[i] ?? ""));
}
